import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';
import { AFFIX } from '../constants';

class Affix extends React.Component {
    static defaultProps = {
        offset: AFFIX.DEFAULT_OFFSET
    };

    debounceWait = 15;

    state = {
        affix: false
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = _.debounce(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const { affix } = this.state;
        const { offset } = this.props;

        if (!affix && scrollTop >= offset) {
            this.setState(() => ({
                affix: true
            }));
        }

        if (affix && scrollTop < offset) {
            this.setState(() => ({
                affix: false
            }));
        }
    }, this.debounceWait);

    render() {
        const { className, ...props } = this.props;
        const affixClass = classNames(className, { affix: this.state.affix });
        return (
            <div {...props} className={affixClass}>
                {this.props.children}
            </div>
        );
    }
}

Affix.propTypes = {
    offset: PropTypes.number
};

export default Affix;



// WEBPACK FOOTER //
// ./components/affix/index.jsx